import React from 'react';
import './Contacts.css';

const ContactCard = (props) => {
  const person = props.person ? props.person : null;
  if (!person) {
    return (
      <div>loading...</div>
    )
  }

  return (
    <div className="Person">
      {props.person._source.app && props.person._source.app !== 'exaContact' ?
        <p>from <b>{props.person._source.app}</b> account of {props.person._source.appOwner} </p> : null
      }
      {props.person._source.nameFull ?
        <p>Display Name: {props.person._source.nameFull}</p> : null
      }
      {props.person._source.contactId ?
        <p>Contact Id: {props.person._source.contactId}</p> : null
      }
      {props.person._source.appContactId && props.person._source.appContactId !== props.person._source.contactId ?
        <p>{props.person._source.app} Id: {props.person._source.appContactId}</p> : null
      }
      {props.person._source.exaOwner ?
        <p>owner: {props.person._source.exaOwner}</p> : null
      }
      {props.person._id ?
        <p>db _id: {props.person._id}</p> : null
      }
      {props.person._source.exaLabel ?
        <p>labels: {props.person._source.exaLabel}</p> : null
      }
      {props.person._source.exaShare ?
        <p>sharing: {props.person._source.exaShare}</p> : null
      }
    </div>
  );
}

export default ContactCard;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactCard.js